import { render, staticRenderFns } from "./ReportsFilterAdvisor.vue?vue&type=template&id=2b1c0ce6&scoped=true"
import script from "./ReportsFilterAdvisor.vue?vue&type=script&lang=js"
export * from "./ReportsFilterAdvisor.vue?vue&type=script&lang=js"
import style0 from "./ReportsFilterAdvisor.vue?vue&type=style&index=0&id=2b1c0ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c0ce6",
  null
  
)

export default component.exports